import _ from "lodash"

export default {
    props: ["editPermissionName"],
    computed: {
        accountPerms: function () {
            return this.$store.state.user.permissions;
        },
        hasEditPermission: function () {
            return _.indexOf(this.accountPerms, this.editPermissionName) >= 0
        }
    }
}